import React from 'react'
import { MapPin, Clock, Phone, Mail, Instagram } from 'lucide-react';

import BookingButton from './components/BookingButton';

function SecondSection() { 
  const locations = [
    {
      name: 'Papakilo Hairstudio - Pusat',
      address: 'The City Resort Residence Rukan Malibu Bl. H, Jl. Boulevard Raya No. 2-3, Cengkareng Tim., Kecamatan Cengkareng, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11730',
      phone: '+62 852-8241-1391',
      email: 'papakilobarbershop@gmail.com',
      instagram: '@papakilo.hairstudio',
      hours: {
        everyday: '10:00 - 22.00 WIB',
      }
    }
  ];

  const features = [
    'Ruang tunggu nyaman dengan WiFi gratis',
    'Area parkir luas',
    'Snack & Mineral gratis',
    'Pembayaran digital',
    'Produk hair styling premium'
  ];

  return (
    <main className="container mx-auto px-4 py-16">
     <div className="max-w-6xl mx-auto">
       {/* Location Cards */}
       {locations.map((location, index) => (
         <div key={index} className="bg-white rounded-lg shadow-xl overflow-hidden mb-8">
           {/* Map Placeholder */}
           <div className="h-96 bg-gray-200 relative">
             <iframe 
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.9747123943266!2d106.73098297413!3d-6.13409996013773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a1daa57288591%3A0xeaaadc216ae9bbce!2sPapakilo%20Barbershop%20landed%20in%20Japan!5e0!3m2!1sid!2sid!4v1739426862957!5m2!1sid!2sid" 
               alt="Map location" 
               className="w-full h-full object-cover"
               referrerpolicy="no-referrer-when-downgrade"
             />
             <a 
                href="https://www.google.com/maps/dir/?api=1&destination=-6.134073932372211,106.73355385491381"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute bottom-4 right-4 bg-purple-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-purple-700 transition-colors"
              >
                Lihat di Google Maps
              </a>
           </div>

           {/* Location Info */}
           <div className="p-8">
             <h2 className="text-3xl font-bold text-gray-800 mb-6">{location.name}</h2>
             
             <div className="grid md:grid-cols-2 gap-8">
               {/* Contact Info */}
               <div className="space-y-6">
                 <div className="flex items-start space-x-4">
                   <MapPin className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
                   <div>
                     <h3 className="font-semibold text-gray-800 mb-1">Alamat</h3>
                     <p className="text-gray-600">{location.address}</p>
                   </div>
                 </div>

                 <div className="flex items-start space-x-4">
                   <Clock className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
                   <div>
                     <h3 className="font-semibold text-gray-800 mb-1">Jam Operasional</h3>
                     <p className="text-gray-600">Senin - Minggu: {location.hours.everyday}</p>
                   </div>
                 </div>

                 <div className="flex items-start space-x-4">
                   <Phone className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
                   <div>
                     <h3 className="font-semibold text-gray-800 mb-1">Telepon</h3>
                     <p className="text-gray-600">{location.phone}</p>
                   </div>
                 </div>

                 <div className="flex items-start space-x-4">
                   <Mail className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
                   <div>
                     <h3 className="font-semibold text-gray-800 mb-1">Email</h3>
                     <p className="text-gray-600">{location.email}</p>
                   </div>
                 </div>

                 <div className="flex items-start space-x-4">
                   <Instagram className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
                   <div>
                     <h3 className="font-semibold text-gray-800 mb-1">Instagram</h3>
                     <p className="text-gray-600">{location.instagram}</p>
                   </div>
                 </div>
               </div>

               {/* Features */}
               <div className="bg-gray-50 rounded-lg p-6">
                 <h3 className="text-xl font-bold text-gray-800 mb-4 ">Fasilitas</h3>
                 <ul className="space-y-3">
                   {features.map((feature, featureIndex) => (
                     <li key={featureIndex} className="flex items-center capitalize">
                       <span className="w-2 h-2 bg-purple-600 rounded-full mr-3"></span>
                       <span className="text-gray-600">{feature}</span>
                     </li>
                   ))}
                 </ul>
               </div>
             </div>
           </div>
         </div>
       ))}

       {/* Booking CTA */}
       <div className="bg-gradient-to-r from-purple-600 to-blue-500 rounded-lg p-8 text-white text-center">
         <h2 className="text-3xl font-bold mb-4">Siap untuk tampil baru?</h2>
         <p className="text-lg mb-6">Booking appointment sekarang dan dapatkan pengalaman potong rambut terbaik</p>
         <BookingButton />
       </div>
     </div>
   </main>
  )
}

export default SecondSection